const state = {
    item: {},
    pageKey: 'external_device',
    pageName: 'External Device',
    excludes: 'ExternalDeviceDetailsTracks'
}

const mutations = {
    SET_ITEM: (state, item) => {
        state.item = item
    },
    PATCH_ITEM: (state, data) => {
        state.item = Object.assign({}, state.item, data)
    },
    REMOVE_ITEM: (state) => {
        state.item = {}
    },
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}